import { ProductPreviewFrame } from "./ProductPreviewFrame";

const HERO_IMAGE = {
  webp: "/landing/hero-product-dashboard.webp",
  png: "/landing/hero-product-dashboard.png",
  width: 1280,
  height: 1054,
  alt: "BurnChart financial snapshot showing runway, cash on hand, monthly expenses, and projected zero-cash date on an interactive timeline",
} as const;

export function LandingHeroScreenshot({ className = "" }: { className?: string }) {
  return (
    <ProductPreviewFrame title="app.burn-chart.com" className={className}>
      <div className="relative overflow-hidden bg-[#12141c]">
        <picture>
          <source srcSet={HERO_IMAGE.webp} type="image/webp" />
          <img
            src={HERO_IMAGE.png}
            alt={HERO_IMAGE.alt}
            width={HERO_IMAGE.width}
            height={HERO_IMAGE.height}
            loading="eager"
            decoding="async"
            className="block w-full object-cover object-top lg:max-h-[min(560px,72vh)]"
          />
        </picture>
        <div
          className="pointer-events-none absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-[#12141c] via-[#12141c]/80 to-transparent"
          aria-hidden
        />
      </div>
    </ProductPreviewFrame>
  );
}
